<template>
    <div
        class="talk-bubble"
        :class="{
            top: arrow !== 'bottom' && arrow !== 'left' && arrow !== 'right', // Default Top
            bottom: arrow === 'bottom',
            left: arrow === 'left',
            right: arrow === 'right',
        }"
        :style="{
            '--xy': adjustedPostition ? adjustedPostition : '50%',
            '--bgColor': bgColor ? bgColor : 'rgba(0, 0, 0, 0.03)',
        }"
    >
        <slot class="body"/>
    </div>
</template>

<script>
export default {
    props: ["arrow", "adjustedPostition", "bgColor"],
};
</script>

<style scoped lang="scss">
.talk-bubble {
    margin-top: 10px;
    background-color: var(--bgColor);
    border-radius: 1rem;
    position: relative;

    > .body {
        width: 100%;
        height: 100%;
    }

    &::before {
        position: absolute;
        width: 0;
        height: 0;
        border-style: solid;
        content: "";
    }

    &.top::before {
        border-width: 0 10px 10px 10px;
        border-color: transparent transparent var(--bgColor) transparent;
        top: 0;
        left: var(--xy);
        transform: translate(-50%, -100%);
    }

    &.bottom::before {
        border-width: 10px 10px 0 10px;
        border-color: var(--bgColor) transparent transparent transparent;
        bottom: 0;
        left: var(--xy);
        transform: translate(-50%, 100%);
    }

    &.left::before {
        border-width: 10px 10px 10px 0;
        border-color: transparent var(--bgColor) transparent transparent;
        top: var(--xy);
        left: 0;
        transform: translate(-100%, -50%);
    }

    &.right::before {
        border-width: 10px 0 10px 10px;
        border-color: transparent transparent transparent var(--bgColor);
        top: var(--xy);
        right: 0;
        transform: translate(100%, -50%);
    }
}
</style>
